"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_calendar_configuration_1 = require("owa-calendar-configuration");
var owa_trace_1 = require("owa-trace");
function loadCalendarMailboxConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, owa_calendar_configuration_1.initCalendarMailboxConfiguration()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, true];
                case 2:
                    e_1 = _a.sent();
                    owa_trace_1.trace.warn(e_1.message || 'loadCalendarMailboxConfiguration failed');
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.default = loadCalendarMailboxConfiguration;
//# sourceMappingURL=loadCalendarMailboxConfiguration.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-options-calendar/lib/data/loadCalendarMailboxConfiguration.js
// module id = 3767
// module chunks = 2